export default {
      id: "circle__b-point-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__b-point",
      toString: function () {
        return this.url;
      }
    }